import { ReactNode } from 'react';

import { Container, ThemeProvider } from '@mui/material';
import { theme } from 'config/defaultTheme';
import { AdminFooter } from 'features/admin/components/AdminFooter/AdminFooter';
import { AdminHeader } from 'features/admin/components/AdminHeader/AdminHeader';

export interface LpiLayoutTemplateProps {
  children: ReactNode;
}

export default function LpiLayoutTemplate({ children }: LpiLayoutTemplateProps) {
  return (
    <ThemeProvider theme={theme}>
      <AdminHeader />

      <Container maxWidth={false} sx={{ minHeight: '100vh' }}>
        {children}
      </Container>

      <AdminFooter />
    </ThemeProvider>
  );
}
